/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_OverlineInputs */

const en_mk_cap_overline = /** @type {(inputs: Mk_Cap_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rest of it`)
};

const id_mk_cap_overline = /** @type {(inputs: Mk_Cap_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelengkapan`)
};

/**
* | output |
* | --- |
* | "The rest of it" |
*
* @param {Mk_Cap_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_overline = /** @type {((inputs?: Mk_Cap_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_overline(inputs)
	return en_mk_cap_overline(inputs)
});